// extracted by mini-css-extract-plugin
export var container = "Tabs-module--container--adfc3";
export var scrollButton = "Tabs-module--scrollButton--38f24";
export var scrollLeftButton = "Tabs-module--scrollLeftButton--43de5";
export var scrollRightButton = "Tabs-module--scrollRightButton--4ec6b";
export var tab = "Tabs-module--tab--9dee2";
export var tabButton = "Tabs-module--tabButton--a3c7a";
export var tabList = "Tabs-module--tabList--c619c";
export var tabListContainer = "Tabs-module--tabListContainer--e18e3";
export var tabListOverflow = "Tabs-module--tabListOverflow--a6cec";
export var tabs = "Tabs-module--tabs--6285f";
export var wrapper = "Tabs-module--wrapper--438a9";
export var wrapperTouchscreen = "Tabs-module--wrapperTouchscreen--c9fb3";